// src/api/index.js
import axios from "axios";

const API = axios.create({
  baseURL: import.meta.env.VITE_API_URL + "/api",
  withCredentials: true,
});

// ✅ Response interceptor: refresh token if expired
API.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;

    // Handle 401 (unauthorized), retry once after refreshing
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !original.url.includes("/auth/login") &&
      !original.url.includes("/auth/refresh-token")
    ) {
      original._retry = true;
      try {
        await API.post("/auth/refresh-token");
        return API(original); // retry original request
      } catch (e) {
        return Promise.reject(e);
      }
    }

    return Promise.reject(error);
  }
);

//
// ✅ Profile API helpers (added on top, without altering existing code)
//
export const getMyProfile = async () => {
  const res = await API.get("/profile/me");
  return res.data;
};

export const saveMyProfile = async (profileData) => {
  const res = await API.post("/profile", profileData);
  return res.data;
};

export const getUserProfileById = async (userId) => {
  const res = await API.get(`/profile/${userId}`);
  return res.data;
};

export default API;
